import { DetectRolld } from "../../../mixins/detectRolld";
import { DetectMobile } from "../../../mixins/detectmobile";
import {defaultCommonStyles} from "../../../api/constants/colors";

export default {
  state: {
    activePopup: false,
  },
  mutations: {
    setActivePopupState(state, payload) {
      state.activePopup = payload;
    },
  },
  getters: {
    mobileStyles(state, getters, roostate) {
      var styles = roostate.store.ViewConfig.UiColours.Mobile;
      var isRolldStore = DetectRolld.methods.isRolldStore();
      if(roostate.store.ViewConfig.IsNewUi){
        return {
          CommonColorTxt: {
            color: `${styles.CommonColor} !important`,
          },
          StatusPendingTxt: {
            color: `${styles.StatusPending} !important`,
          },
          LinkColorTxt: {
            color: `#0000dd !important`,
          },
          btn: {
            background: styles.ButtonColour,
            border: 0,
            color: styles.ButtonText,
          },
          mobilePlaceOrderButton: {
            borderRadius: "4px",
            lineHeight: "21px",
            fontSize: "16px",
            fontWeight: "600",
          },
          alertInfoBackGround: {
            background:  styles.CommonColor,
          },
          TitleBar: {
            "background-color": `${styles.TitleBar} !important`,
          },
          TitleBarBorderColor: {
            "border-bottom": `14px solid ${styles.TitleBar} !important`,
          },
          nav: {
            "background-color": `${styles.MenuBackground} !important`,
          },
          navText: {
            color: `${styles.MenuText} !important`,
          },
          MenuHighlight: {
            "border-color": `${styles.MenuHighlight} !important`,
            "border-bottom": `3px solid ${styles.MenuHighlight}`,
          },
          MagnifyColor: {
            color: `${styles.MenuHighlightedText} !important`,
          },
          MenuHighlightedText: {
            color: `${styles.MenuHighlightedText} !important`,
          },
          primaryBodyBackground: {
            "background-color": `#eeeeee !important`
          },
          menuItemColor: {
            color: `${styles.CommonColor} !important`,
          },
          primaryBackgroundColour: {
            "background-color":`#eeeeee !important`,
          },
          primaryColour: {
            color: `#212529`,
          },
          primaryColourImportant: {
            color: `#212529 !important`,
          },
          CommonColorBackground: {
            "background-color": `${styles.CommonColor} !important`,
          },
          pendingStatusBackground: {
            "background-color": `${styles.StatusPending} !important`,
          },
          successMsg: {
            color: `#4CAF50`,
            "border-color": `#4CAF50`,
            "border-width": "1px",
            "border-style": "solid",
            "border-radius": ".3rem",
          },
          errorMsg: {
            color: `#E91E63`,
            "border-color": `#E91E63`,
            "border-width": "1px",
            "border-style": "solid",
            "border-radius": ".3rem",
            margin: "0.5rem",
            padding: "0.3rem",
          },
          roolIntoButton: {
            color: "#ffffff",
            "border-color": "#0275d8",
            "border-width": "1px",
            "border-style": "solid",
            "border-radius": ".1rem",
            margin: "0.5rem",
            padding: "0.3rem",
            background: "#0275d8",
            width: "96%",
          },
          rollIntoModifyButton: {
            color: "#0275d8",
            "border-color": "#0275d8",
            "border-width": "2px",
            "border-style": "solid",
            "border-radius": "6px",
            margin: "0.5rem",
            padding: "0.3rem",
            width: "96%",
          },
          primaryColor: {
            color: "#ffffff",
          },
          stepProgressBarBeforeCommonColor: {
            "background-color": `#212529`,
            "border-color": `#212529`,
          },
          stepProgressBarBeforePendingColor: {
            "background-color": `#ededed`,
            "border-color": `#ededed`,
          },
          stepProgressBarAfterCommonColor: {
            "background-color": `#212529`,
          },
          stepProgressBarAfterPendingColor: {
            "background-color": `#ededed`,
          },
          textColour: {
            color: `${styles.TextColour} !important`,
          },
          customButtonColour: {
            "background-color": `${styles.CustomButtonColour} !important`,
          },
        };
      }
      return {
        CommonColorTxt: {
          color: `${styles.CommonColor} !important`,
        },
        StatusPendingTxt: {
          color: `${styles.StatusPending} !important`,
        },
        LinkColorTxt: {
          color: `#0000dd !important`,
        },
        btn: {
          background: styles.ButtonColour,
          border: 0,
          color: styles.ButtonText,
        },
        mobilePlaceOrderButton: {
          borderRadius: isRolldStore ? "50px" : "4px",
          lineHeight: "21px",
          fontSize: "16px",
          fontWeight: "600",
        },
        alertInfoBackGround: {
          background: isRolldStore ? styles.StatusPending : styles.CommonColor,
        },
        TitleBar: {
          "background-color": `${styles.TitleBar} !important`,
        },
        TitleBarBorderColor: {
          "border-bottom": `14px solid ${styles.TitleBar} !important`,
        },
        nav: {
          "background-color": `${styles.MenuBackground} !important`,
        },
        navText: {
          color: `${styles.MenuText} !important`,
        },
        MenuHighlight: {
          "border-color": `${styles.MenuHighlight} !important`,
          "border-bottom": `3px solid ${styles.MenuHighlight}`,
        },
        MagnifyColor: {
          color: `${styles.MenuHighlightedText} !important`,
        },
        MenuHighlightedText: {
          color: `${styles.MenuHighlightedText} !important`,
        },
        primaryBodyBackground: {
          "background-color": isRolldStore
            ? "#fffbf2 !important"
            : `#eeeeee !important`,
        },
        menuItemColor: {
          color: `${styles.CommonColor} !important`,
        },
        primaryBackgroundColour: {
          "background-color": isRolldStore
            ? "#fffbf2 !important"
            : `#eeeeee !important`,
        },
        primaryColour: {
          color: `#212529`,
        },
        primaryColourImportant: {
          color: `#212529 !important`,
        },
        CommonColorBackground: {
          "background-color": `${styles.CommonColor} !important`,
        },
        pendingStatusBackground: {
          "background-color": `${styles.StatusPending} !important`,
        },
        successMsg: {
          color: `#4CAF50`,
          "border-color": `#4CAF50`,
          "border-width": "1px",
          "border-style": "solid",
          "border-radius": ".3rem",
        },
        errorMsg: {
          color: `#E91E63`,
          "border-color": `#E91E63`,
          "border-width": "1px",
          "border-style": "solid",
          "border-radius": ".3rem",
          margin: "0.5rem",
          padding: "0.3rem",
        },
        roolIntoButton: {
          color: "#ffffff",
          "border-color": "#0275d8",
          "border-width": "1px",
          "border-style": "solid",
          "border-radius": ".1rem",
          margin: "0.5rem",
          padding: "0.3rem",
          background: "#0275d8",
          width: "96%",
        },
        rollIntoModifyButton: {
          color: "#0275d8",
          "border-color": "#0275d8",
          "border-width": "2px",
          "border-style": "solid",
          "border-radius": "6px",
          margin: "0.5rem",
          padding: "0.3rem",
          width: "96%",
        },
        primaryColor: {
          color: "#ffffff",
        },
        stepProgressBarBeforeCommonColor: {
          "background-color": `#212529`,
          "border-color": `#212529`,
        },
        stepProgressBarBeforePendingColor: {
          "background-color": `#ededed`,
          "border-color": `#ededed`,
        },
        stepProgressBarAfterCommonColor: {
          "background-color": `#212529`,
        },
        stepProgressBarAfterPendingColor: {
          "background-color": `#ededed`,
        },
        textColour: {
          color: `${styles.TextColour} !important`,
        },
        customButtonColour: {
          "background-color": `${styles.CustomButtonColour} !important`,
        },
      };
    },
    mobileColours(state, getters, roostate) {
      return roostate.store.ViewConfig.UiColours.Mobile;
    },
    desktopStyles(state, getters, roostate) {
      var isRolldStore = DetectRolld.methods.isRolldStore();
      var styles = roostate.store.ViewConfig.UiColours.Desktop;
      var btnRadius = {};
      if (isRolldStore) {
        btnRadius["border-radius"] = "50px";
      }
      return {
        btn: {
          background: styles.ButtonColour,
          border: 0,
          color: styles.ButtonText,
          ...btnRadius,
        },
        commonBtn: {
          ...btnRadius,
        },
        desktopPlaceOrderButton: {
          borderRadius: "4px",
          lineHeight: "21px",
          fontSize: "16px",
          fontWeight: "600",
        },
        CommonColorTxt: {
          color: `${styles.CommonColor} !important`,
        },
        StatusPendingTxt: {
          color: `${styles.StatusPending} !important`,
        },
        LinkColorTxt: {
          color: `#0000dd !important`,
        },
        primaryColor: {
          color: "#ffffff !important",
        },
        alertInfoBackGround: {
          background: isRolldStore ? styles.StatusPending : styles.CommonColor,
        },
        TitleBar: {
          "background-color": styles.TitleBar,
        },
        nav: {
          "background-color": `${styles.MenuBackground} !important`,
        },
        navText: {
          color: `${styles.MenuText} !important`,
        },
        MenuHighlight: {
          "border-color": `${styles.MenuHighlight} !important`,
        },
        MagnifyColor: {
          color: `${styles.MenuHighlightedText} !important`,
        },
        MenuHighlightedText: {
          color: `${styles.MenuHighlightedText} !important`,
        },
        primaryBodyBackground: {
          "background-color": isRolldStore
            ? "#fffbf2 !important"
            : `#eeeeee !important`,
        },
        CommonColorBackground: {
          "background-color": `${styles.CommonColor} !important`,
        },
        pendingStatusBackground: {
          "background-color": `${styles.StatusPending} !important`,
        },
        successMsg: {
          color: `#0275d8`,
          "border-color": `#0275d8`,
          "border-width": "1px",
          "border-style": "solid",
          "border-radius": ".3rem",
        },
        errorMsg: {
          color: `#E91E63`,
          "border-color": `#E91E63`,
          "border-width": "1px",
          "border-style": "solid",
          "border-radius": ".3rem",
        },
        roolIntoButton: {
          "border-color": "#0275d8",
          "border-width": "1px",
          "border-style": "solid",
          background: "#0275d8",
          color: "#ffffff",
          width: "100%",
        },
        rollIntoModifyButton: {
          color: "#0275d8",
          "border-color": "#0275d8",
          "border-width": "2px",
          "border-style": "solid",
          "border-radius": "6px",
          width: "100%",
        },
        stepProgressBarBeforeCommonColor: {
          "background-color": `#212529`,
          "border-color": `#212529`,
        },
        stepProgressBarBeforePendingColor: {
          "background-color": `#ededed`,
          "border-color": `#ededed`,
        },
        stepProgressBarAfterCommonColor: {
          "background-color": `#212529`,
        },
        stepProgressBarAfterPendingColor: {
          "background-color": `#ededed`,
        },
        textColour: {
          color: `${styles.TextColour} !important`,
        },
        customButtonColour: {
          "background-color": `${styles.CustomButtonColour} !important`,
        },
      };
    },

    styles(state, getters) {
      let ismobile = DetectMobile.methods.isMobile();
      let res = ismobile ? getters.mobileStyles : getters.desktopStyles;
      let common = defaultCommonStyles();
      return { ...res, ...common };
    },
    activePopup(state) {
      return state.activePopup;
    },
    buttonStyles(state, getters) {
      let {background, border, color} = DetectMobile.methods.isMobile()
        ? getters.mobileStyles.btn
        : getters.desktopStyles.btn;

      background = background.toString().concat(' !important');
      border = border.toString().concat(' !important');
      color = color.toString().concat(' !important');

      return {background, border, color};
    },
  },
};
